import { shape, number, string } from 'prop-types';
import { userBasicInformationPropTypes } from '../../../user/user/proptypes/UserPropTypes';
import { customerBasicInformationPropTypes } from '../../../user/customer/proptypes/CustomerPropTypes';
import { paymentMethodBasicInformationPropTypes } from '../../payment-method/proptypes/PaymentMethodPropTypes';

const salesTaxBasicInformationPropTypes = {
  id: string.isRequired,
  amount: number.isRequired,
  user: shape({
    userId: number,
    ...userBasicInformationPropTypes
  }),
  customer: shape(customerBasicInformationPropTypes),
  paymentMethod: shape(paymentMethodBasicInformationPropTypes),
  transactionType: shape({
    id: number.isRequired,
    transactionType: string.isRequired
  }),
  salesSessionId: number.isRequired,
  expenseId: number,
  expenseType: shape({
    id: number,
    name: string
  }),
  generalIncomeId: number,
  generalIncomeType: shape({
    id: number,
    name: string
  })
};

export default salesTaxBasicInformationPropTypes;
